import React, { Component } from "react";
import cn from "classnames";
import Recaptcha from "react-recaptcha";
import { FormattedMessage, FormattedHTMLMessage } from "react-intl";

import { reg_email, recaptchaSiteKey } from "../../../common/parameters";
import Seo from "../../../common/helpers/seo";

import Form, { InputText, Submit, InputTextArea, Title, Validation } from "../../components/Form";
import Modal from "../../components/Modal";

import { StyledContact, SpringSm, StyledRecaptcha } from "./styles";
import messages from "./messages";
import { IProps, IState } from "./interfaces";

let $script = (a: string, b: string) => null;
if (process.env.WEBPACK) {
    $script = require("scriptjs");
}

class Contact extends Component<IProps, IState> {
    recaptcha?: Recaptcha;
    constructor(props: IProps) {
        super(props);
        let email = "";
        if (props.user && props.user.email) {
            email = props.user.email;
        }
        this.state = {
            email,
            message: "",
            recaptcha: "",
            sent: false,
            validationEmail: undefined,
            validationMessage: undefined,
            validationRecaptcha: undefined,
            loading: false,
        };
    }
    componentDidMount() {
        if (!this.props.user.loggedIn) {
            $script("https://www.google.com/recaptcha/api.js", "recaptcha");
        }
    }
    changeEmail = (e: React.FormEvent<HTMLInputElement>) => {
        const email = e.currentTarget.value;
        this.setState({ email, validationEmail: undefined });
    };

    changeMessage = (e: React.FormEvent<HTMLTextAreaElement>) => {
        const message = e.currentTarget.value;
        this.setState({ message, validationMessage: undefined });
    };

    changeRecaptcha = (e: string) => {
        let validationRecaptcha = undefined;
        if (!e) {
            validationRecaptcha = "required";
        }
        this.setState({ recaptcha: e, validationRecaptcha });
    };

    sendMessage = () => {
        const { email, message, recaptcha } = this.state;
        const loggedIn = this.props.user.state === "loggedIn";
        if (email.length === 0) this.setState({ validationEmail: "required" });
        if (message.length === 0) this.setState({ validationMessage: "required" });
        if (email.length === 0 || message.length === 0) return;

        if (!reg_email.test(email)) this.setState({ validationEmail: "incorrectEmailFormat" });
        if (message.length < 32) this.setState({ validationMessage: "tooShortMessage" });
        if (message.length > 1000) this.setState({ validationMessage: "tooLongMessage" });

        if (!reg_email.test(email) || message.length < 32 || message.length > 1000) return;

        if (!recaptcha && !loggedIn) return this.setState({ validationRecaptcha: "required" });

        this.setState({ loading: true });

        this.props.post("contact-message", { email, message, "g-recaptcha-response": recaptcha }, res => {
            const { data } = res;
            this.setState({ loading: false });
            if (data.success) {
                this.setState({ email: "", message: "" });
                this.setState({ sent: true });
                if (this.recaptcha) this.recaptcha.reset();
            } else {
                if (res.status === 403) {
                    this.setState({ validationRecaptcha: "required" });
                }
            }
        });
    };
    onload = () => {};

    render() {
        const { email, message, sent, validationEmail, validationMessage, validationRecaptcha, loading } = this.state;
        const {
            intl: { formatMessage },
            intl,
            user,
        } = this.props;

        return (
            <StyledContact marginTop={50} className={cn("spring--shadow", "spring--padding")}>
                <Seo title={formatMessage(messages.contact)} />
                <h2>
                    <FormattedMessage {...messages.contact} />
                </h2>
                <SpringSm>
                    <p>
                        <FormattedHTMLMessage {...messages.p} />
                    </p>
                    <Form disabled={loading}>
                        <InputText
                            email
                            required
                            label={formatMessage(messages.email)}
                            value={email}
                            onChange={this.changeEmail}
                            validation={validationEmail}
                        />
                        <InputTextArea
                            required
                            label={formatMessage(messages.message)}
                            value={message}
                            onChange={this.changeMessage}
                            validation={validationMessage}
                            messageLength={message.length}
                        />
                        {!user.loggedIn && (
                            <StyledRecaptcha className={cn(loading && "Disabled")}>
                                {validationRecaptcha && <Validation validation={validationRecaptcha} />}
                                <Recaptcha
                                    ref={rec => (this.recaptcha = rec!)}
                                    sitekey={recaptchaSiteKey}
                                    render="explicit"
                                    hl={intl.locale}
                                    elementID="contactRecaptcha"
                                    onloadCallback={this.onload}
                                    expiredCallback={() => this.changeRecaptcha("")}
                                    verifyCallback={this.changeRecaptcha}
                                    size="normal"
                                />
                            </StyledRecaptcha>
                        )}
                        <Submit onClick={this.sendMessage} loading={loading}>
                            <FormattedMessage {...messages.send} />
                        </Submit>
                    </Form>

                    {sent && (
                        <Modal close={() => this.setState({ sent: false })}>
                            <Title>
                                <FormattedMessage {...messages.success} />
                            </Title>
                            <Form>
                                <p>
                                    <FormattedMessage {...messages.successMessage} />
                                </p>
                                <Submit onClick={() => this.setState({ sent: false })}>
                                    <FormattedMessage {...messages.close} />
                                </Submit>
                            </Form>
                        </Modal>
                    )}
                </SpringSm>
            </StyledContact>
        );
    }
}

export default Contact;
